export default __webpack_public_path__ + "img/allergy-eggs.svg";